{
  "images": [
    {
      "id": "photo-7",
      "filename": "gallery/photo_7_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 1
    },
    {
      "id": "photo-9",
      "filename": "gallery/photo_9_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 2
    },
    {
      "id": "photo-3",
      "filename": "gallery/photo_3_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 3
    },
    {
      "id": "photo-1",
      "filename": "gallery/photo_1_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 4
    },
    {
      "id": "photo-2",
      "filename": "gallery/photo_2_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 5
    },
    {
      "id": "photo-4",
      "filename": "gallery/photo_4_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 6
    },
    {
      "id": "photo-5",
      "filename": "gallery/photo_5_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 7
    },
    {
      "id": "photo-6",
      "filename": "gallery/photo_6_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 8
    },
    {
      "id": "photo-8",
      "filename": "gallery/photo_8_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 9
    },
    {
      "id": "photo-10",
      "filename": "gallery/photo_10_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 10
    },
    {
      "id": "photo-11",
      "filename": "gallery/photo_11_2026-04-30_06-33-02.jpg",
      "alt": "Restaurant Fey am Tibarg",
      "width": 1280,
      "height": 960,
      "displayOrder": 11
    }
  ]
}
